import React from "react";
import {ListComponent} from "../../components/ListComponent";
import {Loader} from "../../components/Loader";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";

export class ProductList extends ListComponent {

    protected getRequestUrl(): RequestInfo | URL {
        return '/product/list';
    }

    protected navigate(event: any) {
        event.preventDefault();
        let id = event.target.closest('tr').getAttribute('data-id');
        super.navigate(event, '/product/details/' + id);
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        const navigate = this.navigate,
            params: {} | any = this.getFormData(),
            dictionary = this.dictionary;

        return (
            <>
                <div className="row">
                    <form className="x-form" method="POST" onSubmit={this.handleSubmit}>
                        <div className="row">
                            <h5>{this.dictionary.get['search']}</h5>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'id', defaultValue: params?.id}}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'name', defaultValue: params?.name}}/>
                            </div>


                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'sku', defaultValue: params?.sku}}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'barcode', defaultValue: params?.barcode}}/>
                            </div>


                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Select {...{
                                    id: 'status',
                                    basic: 'show-all',
                                    items: ['active', 'inactive'],
                                    defaultValue: params?.status
                                }}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Select {...{
                                    id: 'type',
                                    basic: 'show-all',
                                    items: ['product', 'virtual-product', 'packaging-material', 'flyer', 'bundle', 'pack', 'alias', 'service', 'carton'],
                                    defaultValue: params?.type
                                }}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Select {...{
                                    id: 'unit_cost',
                                    basic: 'show-all',
                                    items: ['with_unit_cost', 'without_unit_cost'],
                                    defaultValue: params?.unit_cost
                                }}/>
                            </div>
                        </div>

                        <input type="hidden" name="sort" defaultValue={params.sort ?? 'id:d'}/>

                        {this.listOfSearchParams(params)}

                        <div className="row">
                            <div className="col-12 caption">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['search']}
                                </button>
                                &nbsp;
                                <button className="btn btn-sm btn-light"
                                        onClick={((event: MouseEvent | any) => {
                                            event.preventDefault();
                                            this.exportTableData('/product/export')
                                        })}>
                                    {this.dictionary.get['export']}
                                </button>
                                &nbsp;
                                &nbsp;
                                <h6>
                                    {this.dictionary.get['products']}: &nbsp;
                                    <strong>{this.state.count ? this.state.count : '-'}</strong> {this.dictionary.get['pc']}
                                </h6>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="row">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead>
                            <tr>
                                <th className="sortable" data-sortkey="p.id">
                                    # <i className="bi bi-sort-down"></i>
                                </th>

                                <th className="sortable" data-sortkey="p.`status`">{this.dictionary.get['status']}</th>
                                <th className="sortable"
                                    data-sortkey="p.`client_id`">{this.dictionary.get['client']}</th>
                                <th className="sortable" data-sortkey="p.`type`">{this.dictionary.get['type']}</th>
                                <th className="sortable" data-sortkey="p.`sku`">
                                    {this.dictionary.get['sku']}
                                    <br/>{this.dictionary.get['barcode']}
                                </th>
                                <th className="sortable" data-sortkey="p.`name`">
                                    {this.dictionary.get['name']}
                                    <br/>
                                    {this.dictionary.get['category']}
                                </th>

                                <th className="sortable" data-sortkey="p.`quantity`" align={"right"}>
                                    {/*{this.dictionary.get['quantity']}<br/>{this.dictionary.get['isolated_quantity']}*/}
                                    {this.dictionary.get['quantity']}
                                </th>

                                <th className="sortable" data-sortkey="COALESCE(pp.quantity, pp2.quantity)" align={"right"}>
                                    {this.dictionary.get['carton-contains']}
                                </th>

                                <th className="sortable" data-sortkey="p.unit_cost" align={"right"}>
                                    {this.dictionary.get['unit_cost']}
                                </th>
                                <th className="sortable" data-sortkey="p.created_at">
                                    {this.dictionary.get['created']}
                                </th>
                                <th className="sortable" data-sortkey="p.created_at">
                                    {this.dictionary.get['updated']}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(function (elem: any) {
                                let createdAt = '-', updatedAt = '-';
                                if (elem.created_at) {
                                    createdAt = (new Date(elem.created_at + ' GMT')).toLocaleString();
                                }
                                if (elem.updated_at) {
                                    updatedAt = (new Date(elem.updated_at + ' GMT')).toLocaleString();
                                }
                                return (
                                    <tr key={elem.id} data-id={elem.id} onMouseDown={navigate}>
                                        <td style={{textAlign: 'right'}}>{elem.id}</td>
                                        <td>{elem.status}</td>
                                        <td>{elem.client}</td>
                                        <td>{elem.type}</td>
                                        <td>{elem.sku ?? '-'}<br/>{elem.barcode ?? '-'}</td>
                                        <td>{elem.name ?? '-'}<br/>{elem.categories ?? '-'}</td>
                                        {/*<td>{elem.width ?? '-'}x{elem.height ?? '-'}x{elem.length ?? '-'} - {elem.volume ?? '-'}</td>*/}
                                        {/*<td>{elem.weight ?? '-'}</td>*/}
                                        <td align={"right"}>{elem.quantity ?
                                            <FormattedNumber value={elem.quantity}
                                                             suffix={dictionary.get['pc']}/> : '-'}</td>
                                        <td align={"right"}>{elem.product_pack_quantity ?
                                            <FormattedNumber value={elem.product_pack_quantity}
                                                             suffix={dictionary.get['pc']}/> : '-'}</td>
                                        <td align={"right"}>{elem.unit_cost ?
                                            <FormattedNumber value={elem.unit_cost} suffix={"EUR"}/> : '-'}</td>
                                        {/*<td>{elem.quantity ?? '-'}<br/>{elem.isolated_quantity ?? '-'}</td>*/}
                                        <td>{createdAt}<br/>{elem.created_by ?? '-'}</td>
                                        <td>{updatedAt}<br/>{elem.updated_by ?? '-'}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            {this.state.itemsCount < this.limit ? (
                                <TableFooter colspan={9}/>
                            ) : ''}
                        </table>
                        {this.state.isLoading && <Loader/>}
                    </div>
                </div>
            </>
        );
    }
}
